import * as React from "react";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Chip from "@mui/material/Chip";
import Tooltip from "@mui/material/Tooltip";

import { useSearch } from "../../contexts/searchContext";
import getCharacteristicsImagePath from "../../services/image/imageService";

/**
 * SelectedCharacteristics - Displays selected filter characteristics with result count
 * @param {Array} myarr - Array of [key, value] pairs representing selected characteristics
 */
export default function SelectedCharacteristics({ myarr }) {
  const { filteredPeople } = useSearch();
  const filteredPeopleCount = filteredPeople.length;

  if (!myarr || myarr.length === 0) {
    return null;
  }

  return (
    <Stack
      direction="row"
      spacing={0.5}
      alignItems="center"
      sx={{
        flexGrow: 1,
        overflow: 'hidden'
      }}
    >
      {Array.from(myarr).map(([key, value]) => (
        <Tooltip key={key} title={`${key}: ${value}`} arrow>
          <Box
            component="img"
            src={getCharacteristicsImagePath(key, value)}
            alt={`${key}: ${value}`}
            sx={{
              width: 28,
              height: 28,
              backgroundColor: 'white',
              borderRadius: 0.5,
              padding: 0.25,
              boxShadow: 1,
              transition: 'transform 0.2s',
              '&:hover': {
                transform: 'scale(1.15)',
                boxShadow: 2,
              }
            }}
          />
        </Tooltip>
      ))}

      {filteredPeopleCount > 0 && (
        <Chip
          label={filteredPeopleCount}
          size="small"
          color="primary"
          sx={{
            ml: 1,
            fontWeight: 600,
            minWidth: 40,
            height: 28
          }}
        />
      )}
    </Stack>
  );
}
